import { useTranslation } from '../../context/LanguageContext';
import '../policy/policy.scss';

const Terms = () => {
  const { content } = useTranslation();
  const t = content.termsPage;

  return (
    <main className="policy-page">
      <section className="policy-hero section-full">
        <div className="container">
          <h1 className="policy-hero__title">{t.title}</h1>
          <p className="policy-hero__updated">{t.updated}</p>
        </div>
      </section>

      <section className="policy-body section-full">
        <div className="container">
          <p className="policy-body__intro">{t.intro}</p>
          <div className="policy-list">
            {t.sections.map((item) => (
              <article className="policy-item" key={item.heading}>
                <h2>{item.heading}</h2>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Terms;
